/* FP Welcome popup — entrance email capture.
   Posts to Klaviyo's client subscription API (public site id only — no
   private key in the browser). Subscribing to the list triggers the
   Klaviyo welcome flow, which delivers the 20% code by email. */
(function () {
  'use strict';

  var root = document.getElementById('fp-welcome-popup');
  if (!root) return;

  var STORE_KEY = 'fp_wp_state_v1';
  var cfg = {
    delay: parseInt(root.getAttribute('data-delay'), 10) || 7,
    repeatDays: parseInt(root.getAttribute('data-repeat-days'), 10) || 30,
    exitIntent: root.getAttribute('data-exit-intent') === 'true',
    klaviyoCompany: root.getAttribute('data-klaviyo-company') || '',
    klaviyoList: root.getAttribute('data-klaviyo-list') || '',
    code: root.getAttribute('data-code') || '',
    exclude: (root.getAttribute('data-exclude') || '')
      .split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean)
  };

  var overlay = root;
  var dialog = root.querySelector('.fp-wp');
  var form = root.querySelector('.fp-wp__form');
  var emailInput = root.querySelector('#fp-wp-email');
  var nameInput = root.querySelector('#fp-wp-name');
  var consentInput = root.querySelector('#fp-wp-consent');
  var errorEl = root.querySelector('.fp-wp__error');
  var submitBtn = root.querySelector('.fp-wp__submit');
  var lastFocused = null;
  var opened = false;

  function readState() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) s[k] = patch[k]; }
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function track(name, payload) {
    window.dataLayer = window.dataLayer || [];
    var d = { event: name };
    for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) d[k] = payload[k]; }
    window.dataLayer.push(d);
  }

  function pathExcluded() {
    var p = window.location.pathname.toLowerCase();
    for (var i = 0; i < cfg.exclude.length; i++) {
      if (cfg.exclude[i] && p.indexOf(cfg.exclude[i]) === 0) return true;
    }
    return false;
  }

  /* Best effort: skip visitors Klaviyo has already identified on this
     device (e.g. arrived via a Klaviyo email link). */
  function klaviyoIdentified() {
    try { return document.cookie.indexOf('__kla_id=') !== -1 && readState().subscribed; }
    catch (e) { return false; }
  }

  function shouldShow() {
    if (!cfg.klaviyoCompany || !cfg.klaviyoList) return false;
    if (pathExcluded()) return false;
    var s = readState();
    if (s.subscribed) return false;
    if (klaviyoIdentified()) return false;
    if (s.dismissedAt) {
      var days = (Date.now() - s.dismissedAt) / 86400000;
      if (days < cfg.repeatDays) return false;
    }
    return true;
  }

  /* ---- Focus management ---- */
  function focusables() {
    return Array.prototype.slice.call(dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { close('escape'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (opened || !shouldShow()) return;
    opened = true;
    lastFocused = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    var f = focusables();
    if (f.length) f[0].focus();
    writeState({ shownAt: Date.now() });
    track('welcome_popup_shown', { popup_offer: cfg.code });
  }

  function close(reason) {
    if (!opened) return;
    opened = false;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (!readState().subscribed) writeState({ dismissedAt: Date.now() });
    track('welcome_popup_dismissed', { popup_dismiss_reason: reason || 'close' });
  }

  /* ---- Submit (Klaviyo client subscription API) ---- */
  function submit(email, firstName) {
    var attrs = { email: email, properties: { signup_source: 'welcome-popup' } };
    if (firstName) attrs.first_name = firstName;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'FP Welcome Popup',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.klaviyoList } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoCompany), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-01-15' },
      body: JSON.stringify(payload)
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailInput.value || '').trim();
      var firstName = nameInput ? (nameInput.value || '').trim() : '';
      var consent = consentInput ? consentInput.checked : true;

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = 'Please enter a valid email address so we can send your code.';
        emailInput.focus();
        return;
      }
      if (consentInput && !consent) {
        errorEl.textContent = 'Please tick the box so we can email your code to you.';
        consentInput.focus();
        return;
      }
      errorEl.textContent = '';
      submitBtn.disabled = true;

      submit(email, firstName).then(function (res) {
        if (!res.ok) throw new Error('subscribe failed: ' + res.status);
        writeState({ subscribed: true, subscribedAt: Date.now() });
        dialog.classList.add('is-done');
        track('welcome_popup_signup', { popup_offer: cfg.code, popup_consent: 'yes' });
        var copyBtn = root.querySelector('.fp-wp__copy');
        if (copyBtn) copyBtn.focus();
      }).catch(function () {
        submitBtn.disabled = false;
        errorEl.textContent = 'Sorry — that didn’t go through. Please try again in a moment.';
      });
    });
  }

  /* ---- Copy code ---- */
  var copyBtn = root.querySelector('.fp-wp__copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var done = function () {
        var original = copyBtn.getAttribute('data-label') || copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = original; }, 2000);
        track('welcome_popup_code_copied', { popup_offer: cfg.code });
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(cfg.code).then(done, done);
      } else { done(); }
    });
  }

  /* ---- Close bindings ---- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-fp-wp-close]'), function (el) {
    el.addEventListener('click', function () { close(el.getAttribute('data-fp-wp-close')); });
  });
  overlay.addEventListener('mousedown', function (e) {
    if (e.target === overlay) close('backdrop');
  });

  /* ---- Triggers ---- */
  if (shouldShow()) {
    setTimeout(open, cfg.delay * 1000);

    if (cfg.exitIntent && window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('mouseout', function onOut(e) {
        if (e.clientY > 0 || e.relatedTarget) return;
        document.removeEventListener('mouseout', onOut);
        open();
      });
    }
  }
})();
